export const iconFontAwesomeUsersPeopleUsers = (
	<i className="fa-solid fa-users"></i>
);
